<template>
  <section class="our_suggestion">
    <div class="wrapper">
      <div class="all_title_block right_title_block">
        <div class="title_block">
          <span>{{ $store.getters.t('Popular_posts') }}</span>
          <div></div>
        </div>
      </div>
      <div class="blocks">
        <div class="block" v-for="post in posts" :key="post.id">
          <div class="img">
            <router-link
              :to="{
                name: 'blog.category.post',
                params: {
                    lang: $store.getters.locale,
                    category: post.category_slug,
                    post: post.slug,
                }
              }"
            >
              <img :src="post.photo">
            </router-link>
          </div>
          <div class="text_block">
            <div class="name_block">
              <router-link
                :to="{
                  name: 'blog.category.post',
                  params: {
                      lang: $store.getters.locale,
                      category: post.category_slug,
                      post: post.slug,
                  }
                }"
              >{{post.name}}</router-link>
            </div>
            <p v-html="post.short_content"></p>
            <div class="read_more">
              <router-link
                :to="{
                  name: 'blog.category.post',
                  params: {
                      lang: $store.getters.locale,
                      category: post.category_slug,
                      post: post.slug,
                  }
                }"
              >{{ $store.getters.t('Read_more') }}...</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  props: ["posts"]
};
</script>





// WEBPACK FOOTER //
// resources/js/components/widgets/ActivePosts.vue